import * as React from 'react';
import { Button, Card, Col, Form, Row, Spinner } from 'react-bootstrap';
import { useAuthContext } from '../contexts/AuthContext';
import { ILoginData2fa } from '../services/AuthService';
import { useHistory } from 'react-router';
import { Redirect, useLocation } from 'react-router-dom';
import { Formik } from 'formik';
import * as yup from 'yup';

export const Login2faPage = (props: any) => {
    const [loginError, setLoginError] = React.useState(false);
    const codeInput = React.useRef<HTMLInputElement>(null);
    const authContext = useAuthContext();
    const history = useHistory();
    const [isLockedOut, setIsLockedOut] = React.useState(false);

    React.useLayoutEffect(() => {
        if (codeInput.current !== null) {
            codeInput.current.focus();
        }
    });

    const validationSchema = yup.object().shape({
        code: yup.string().required()
    });

    const useQuery = () => {
        const { search } = useLocation();
        return React.useMemo(() => new URLSearchParams(search), [search]);
    }
    const query = useQuery();
    
    return (
        <>
        {/* {authContext.user && <Redirect to="/documentation" />} */}
        {!props.location.state && <Redirect to="/login" />}
        <Formik 
            validationSchema={validationSchema}
            initialValues = {{
                code: ""                
            }}
            onSubmit={async (values: any, actions: any) => {
                const loginData: ILoginData2fa = {
                    code: values.code,
                    email: props.location.state.email
                };
                const apiResponse = await authContext.logIn(loginData);
                actions.setSubmitting(false);
                if (!apiResponse.error) {
                    const redirectUrl = query.get("redirectUrl");
                    history.replace(redirectUrl ?? '/documentation'); 
                } else {
                    if (apiResponse.data.response && apiResponse.data.response.status === 401) {
                        if (apiResponse.data.response.data.detail === "isLockedOut") {
                            setIsLockedOut(true);
                        } else {
                            setLoginError(true);
                        }
                    } else {
                        props.apiError(true);
                        props.showToast(true);
                        props.toastMessage("Oops, something went wrong");
                    }
                }
            }}
        >
        {({ handleSubmit, handleChange, handleBlur, isSubmitting, errors, touched, values }) => (
            <div>
                {isLockedOut ? ( 
                    <Row className="min-vh-85 justify-content-center">
                        <Col sm={12} className="mw-520 align-self-center">
                            <Card className="my-5">
                                <Card.Body className="overflow-hidden">
                                    <div className="text-center mb-3">
                                        <svg width="40" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17.9096 0.116455C8.01799 0.116455 0 8.18027 0 18.1284C0 28.0766 8.01799 36.1404 17.9096 36.1404C27.8012 36.1404 35.8192 28.0766 35.8192 18.1284C35.8192 8.18027 27.8012 0.116455 17.9096 0.116455ZM15.4448 26.6741C18.2104 26.6741 20.5046 27.7545 22.2194 29.5039C22.304 29.5904 22.4381 29.5995 22.5319 29.5236C25.8417 26.8234 27.964 22.7116 27.964 18.0931C27.964 17.932 27.9601 17.7723 27.9536 17.6125C28.6476 16.2952 29.0603 14.8036 29.1046 13.2126C29.128 12.3601 29.0395 11.5312 28.8585 10.7364C28.8299 10.6094 28.6476 10.6172 28.6306 10.7469C28.4783 11.9608 28.0577 13.1118 27.4197 14.1214C27.296 13.6801 27.1554 13.2454 26.9927 12.8224C26.9067 12.5919 26.7336 12.1978 26.6177 11.9385C26.5422 11.7696 26.4627 11.6033 26.369 11.4448C25.1164 9.32869 22.8209 7.91051 20.1986 7.91051C18.476 7.91051 16.9031 8.51681 15.6701 9.53428C15.6701 9.53428 15.6701 9.53428 15.6701 9.53297C14.7652 7.34744 13.1324 5.54165 11.0804 4.4155C13.135 3.37838 15.454 2.79304 17.9096 2.79304C26.3299 2.79304 33.1552 9.65737 33.1552 18.1258C33.1552 26.5943 26.3299 33.4586 17.9096 33.4586C14.2274 33.4586 10.8499 32.1452 8.21459 29.9596C10.4606 27.3236 12.8251 26.6754 15.4448 26.6754V26.6741ZM9.51403 8.23003C9.54138 8.1017 9.72366 8.10956 9.74319 8.23919C10.139 10.9655 12.1962 13.2676 15.0373 13.8228C15.1701 13.849 15.8237 13.9878 16.0243 14.0271C16.8966 14.2013 17.5476 14.9346 17.5724 15.829C17.6075 17.0795 16.437 18.0433 15.2391 17.7081C11.9202 16.7784 9.44242 13.7613 9.34216 10.1157C9.32393 9.46749 9.38643 8.83763 9.51403 8.23134V8.23003ZM18.9747 18.516C19.2885 17.97 20.2377 17.932 21.0944 18.4296C21.9525 18.9272 22.2506 20.0233 22.0801 20.3192C21.9095 20.6165 20.8171 20.9032 19.9603 20.4056C19.1023 19.908 18.6609 19.0621 18.9747 18.516Z" fill="#28B56F"></path>
                                        </svg>
                                    </div>
                                    <h3 className="text-center">Developer Portal</h3>
                                    <h6 className="text-center font-regular text-gray mb-4">Account Locked</h6>
                                    <div> 
                                        <span>
                                            You have attempted an invalid verification code too many times.  Please try logging in again later.
                                        </span>
                                        </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                ) : (
                    <Row className="min-vh-85 justify-content-center">
                        <Col xs={12} className="mw-520 align-self-center">
                            <Card className="my-5">
                                <Card.Body className="overflow-hidden">
                                    <div className="text-center mb-3">
                                        <svg width="40" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17.9096 0.116455C8.01799 0.116455 0 8.18027 0 18.1284C0 28.0766 8.01799 36.1404 17.9096 36.1404C27.8012 36.1404 35.8192 28.0766 35.8192 18.1284C35.8192 8.18027 27.8012 0.116455 17.9096 0.116455ZM15.4448 26.6741C18.2104 26.6741 20.5046 27.7545 22.2194 29.5039C22.304 29.5904 22.4381 29.5995 22.5319 29.5236C25.8417 26.8234 27.964 22.7116 27.964 18.0931C27.964 17.932 27.9601 17.7723 27.9536 17.6125C28.6476 16.2952 29.0603 14.8036 29.1046 13.2126C29.128 12.3601 29.0395 11.5312 28.8585 10.7364C28.8299 10.6094 28.6476 10.6172 28.6306 10.7469C28.4783 11.9608 28.0577 13.1118 27.4197 14.1214C27.296 13.6801 27.1554 13.2454 26.9927 12.8224C26.9067 12.5919 26.7336 12.1978 26.6177 11.9385C26.5422 11.7696 26.4627 11.6033 26.369 11.4448C25.1164 9.32869 22.8209 7.91051 20.1986 7.91051C18.476 7.91051 16.9031 8.51681 15.6701 9.53428C15.6701 9.53428 15.6701 9.53428 15.6701 9.53297C14.7652 7.34744 13.1324 5.54165 11.0804 4.4155C13.135 3.37838 15.454 2.79304 17.9096 2.79304C26.3299 2.79304 33.1552 9.65737 33.1552 18.1258C33.1552 26.5943 26.3299 33.4586 17.9096 33.4586C14.2274 33.4586 10.8499 32.1452 8.21459 29.9596C10.4606 27.3236 12.8251 26.6754 15.4448 26.6754V26.6741ZM9.51403 8.23003C9.54138 8.1017 9.72366 8.10956 9.74319 8.23919C10.139 10.9655 12.1962 13.2676 15.0373 13.8228C15.1701 13.849 15.8237 13.9878 16.0243 14.0271C16.8966 14.2013 17.5476 14.9346 17.5724 15.829C17.6075 17.0795 16.437 18.0433 15.2391 17.7081C11.9202 16.7784 9.44242 13.7613 9.34216 10.1157C9.32393 9.46749 9.38643 8.83763 9.51403 8.23134V8.23003ZM18.9747 18.516C19.2885 17.97 20.2377 17.932 21.0944 18.4296C21.9525 18.9272 22.2506 20.0233 22.0801 20.3192C21.9095 20.6165 20.8171 20.9032 19.9603 20.4056C19.1023 19.908 18.6609 19.0621 18.9747 18.516Z" fill="#28B56F"></path>
                                        </svg>
                                    </div>
                                    <h3 className="text-center">Developer Portal</h3>
                                    <h6 className="text-center font-regular text-gray mb-4">Login Verification</h6>
                                    <p>Please enter the 6-digit code sent to {props.location.state ? props.location.state.email : ""}:</p>
                                    <Form noValidate onSubmit={handleSubmit}>
                                        <Form.Group controlId="codeInput">
                                            <Form.Control 
                                                isInvalid={touched.code && !!errors.code}
                                                maxLength={6} 
                                                name="code" 
                                                onBlur={(e: any) => {
                                                    if (e.currentTarget.value.length > 0) {
                                                        handleBlur(e);
                                                    }
                                                }} 
                                                onChange={handleChange} 
                                                placeholder="Verification code" 
                                                ref={codeInput}
                                                type="text" 
                                                value={values.code}
                                            />
                                        </Form.Group>
                                        <Button type="submit" variant="success" className="rounded-pill" disabled={isSubmitting} block>
                                            {isSubmitting ? (
                                                <React.Fragment>
                                                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                                    <span>&nbsp;Verifying...</span>
                                                </React.Fragment>
                                            ) : (
                                                <React.Fragment>
                                                    <span>Verify</span>
                                                </React.Fragment>                                       
                                            )}
                                        </Button>
                                    </Form>
                                    {loginError && <p className="text-center text-danger">Verification failed. Please try again.</p>}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                )}
            </div>
        )}
        </Formik>
        </>
    );
};